<template>
  <div>
    <h5 class="section-title">{{ $t("pages.wording.reserveTitle") }}</h5>
    <CardTable>
      <!-- 抵達廠區 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.reserveArea") }}</div>
        <div class="value">{{ infoData.reserveData.reserveFactory }}</div>
      </div>
      <!-- 抵達地點 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.reserveLocation") }}</div>
        <div class="value">{{ $store.getters.getSysCodeText("location", infoData.reserveData.reserveLocation) }}</div>
      </div>
      <!-- 隨行人 -->
      <span v-if="infoData.reserveData.length > 0">
        <div class="card-item" v-for="(item, index) in infoData.reserveData" :key="item">
          <div class="label">{{ $t("pages.wording.entourage") }}{{ index + 1 }}/{{ $t("pages.wording.idNum") }}</div>
          <div class="value">{{ item.entourageName }} / {{ item.entourageID }}</div>
        </div>
      </span>
      <!-- 台達接洽人 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.deltaContactName") }}</div>
        <div class="value">{{ infoData.reserveData.deltaContactName }}</div>
      </div>
      <!-- 接洽人電話 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.deltaContactNumber") }}</div>
        <div class="value">{{ infoData.reserveData.deltaContactNumber }}</div>
      </div>
    </CardTable>
    <h5 class="section-title">{{ $t("pages.wording.reserveTime") }}</h5>
    <CardTable>
      <!-- 預約進廠時間 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.reserveArriveTime") }}</div>
        <div class="value">
          {{ formateDatetimeStr("DateTime", infoData.reserveData.reserveArriveDatetime) }}
        </div>
      </div>
      <!-- 實際進廠時間 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.enteringTime") }}</div>
        <div class="value">{{ formateDatetimeStr("DateTime", infoData.reserveData.enteringDatetime) }}</div>
      </div>
      <!-- 實際離廠時間 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.leaveDate") }}</div>
        <div class="value">{{ formateDatetimeStr("DateTime", infoData.reserveData.leaveDatetime) }}</div>
      </div>
      <!-- 實際停留時間 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.stayDelay") }}</div>
        <div class="value">{{ infoData.reserveData.stayTime }}</div>
      </div>
      <!-- 逾期原因 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.stayReason") }}</div>
        <div class="value">{{ $store.getters.getSysCodeText("delayReason", infoData.reserveData.stayReason) }}</div>
      </div>
    </CardTable>
  </div>
</template>

<script>
import CardTable from "@/components/common/CardTable.vue"
import { utils } from "@/utils/utils.js"

export default {
  name: "GuardDetailedInfo",
  props: {
    infoData: Object,
  },
  components: {
    CardTable,
  },
  data() {
    return {}
  },
  methods: {
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
}
</script>

<style scoped>
.CardTable:not(:last-child) {
  margin-bottom: 24px;
}
.section-title {
  margin-bottom: 16px;
  font-weight: bold;
  font-size: var(--subTitle-font-size);
  line-height: var(--subTitle-line-height);
}
.form-button {
  color: var(--blue500);
  font-size: var(--button-font-size);
  line-height: var(--button-line-height);
  font-weight: 700;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 8px;
  margin-left: 16px;
}
.form-button i {
  font-size: 18px;
  margin-right: 4px;
}
</style>
